import { render, staticRenderFns } from "./recoveryServeExplain.vue?vue&type=template&id=ccc57660&scoped=true&"
import script from "./recoveryServeExplain.vue?vue&type=script&lang=js&"
export * from "./recoveryServeExplain.vue?vue&type=script&lang=js&"
import style0 from "./recoveryServeExplain.vue?vue&type=style&index=0&id=ccc57660&lang=scss&scoped=true&"
import style1 from "./recoveryServeExplain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc57660",
  null
  
)

export default component.exports